import CmsPageQuery from 'Query/CmsPage.query';
import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/NoMatch/Query */
export class NoMatchQuery {
    getPushPage404() {
        return new Field('getPushPage404')
            .addFieldList(CmsPageQuery._getPageTeaserFields());
    }
}

export default new NoMatchQuery();
